<!-- 乡镇下村庄所有村民报抽统计 -->

<template>
    <div class="main-area">
        <div v-if="$route.meta.rank == 4">
            <el-breadcrumb separator=":">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item>抽污情况数据统计</el-breadcrumb-item>
            </el-breadcrumb>

            <el-page-header @back="goBack" content="" class="margin-top-20"></el-page-header>

            <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading" class="margin-top-20">
                <el-table-column
                    type="index"
                    width="50" label="序号">
                </el-table-column>
                <el-table-column prop="cjdwdmName" label="所属区划" align="center"/>
                <el-table-column prop="mbrxm" label="改厕户姓名" align="center"/>
                <el-table-column prop="mbrsjh" label="手机号码" align="center"/>
                <el-table-column prop="cjsj" label="报抽时间" align="center" :formatter="formatterTime"/>
                <el-table-column prop="zt" label="状态" align="center" :formatter="formatterStatus"/>
                <el-table-column prop="dcrUuidName" label="抽污责任人" align="center"/>
                <el-table-column prop="wcsj" label="抽污时间" align="center" :formatter="formatterTime"/>
            </el-table>

            <el-pagination
                class="margin-top-10 margin-bottom-20"
                @size-change="tableSizeChange"
                @current-change="currentChange"
                :current-page="pagination.currentPage"
                :page-sizes="pagination.pageSizeList"
                :page-size="pagination.pageSize"
                :layout="pagination.layout"
                :total="pagination.total">
            </el-pagination>
        </div>
        <div v-else><router-view></router-view></div>
    </div>
</template>

<script>
export default {
    name: 'TownPeopleBCStatistics',
    data() {
        return {
            tableData: [
            ],
            // 查询表单
            searchForm: {
                updateTime: ''
            },
            loading: false,
            // 路由传递村庄code
            townCode:'',
            // 分页参数
            pagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
        }
    },

    methods: {
        getTableData(initPageFlag) {
            this.loading = true
            let _this = this, searchParams = this.searchForm
            let beginTime = ''
            let endTime = ''
            _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
            var reg = /-| |:/g
             console.log(_this.searchForm)
            if (_this.searchForm.updateTime) {
                if (_this.searchForm.updateTime[0]) {
                    beginTime = _this.searchForm.updateTime[0].replace(reg, '') + '00'
                }
                if (_this.searchForm.updateTime[1]) {
                    endTime = _this.searchForm.updateTime[1].replace(reg, '') + '00'
                }
            }
            // 3、 调接口获取数据
            let param = {
                // baseService : "TGcBcxxServiceImpl",
                baseService: _this.GLOBAL.config.baseServiceType.TGcBcxxServiceImpl,
                current: initPageFlag ? 1 : _this.pagination.currentPage,
                size: initPageFlag ? 10 : _this.pagination.pageSize,
                records: [{
                  code: _this.townCode,
                  beginTime: beginTime,
                  endTime: endTime
                  }]

            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getPageNew,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj.records;
                        _this.pagination.pageSize = resultData.obj.size
                        _this.pagination.total = resultData.obj.total
                        _this.pagination.currentPage = resultData.obj.current
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },
        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData()
        },
        formatterStatus(row, column, data) {
            let str = "";
            switch (data) {
                case '0':
                    str = "未抽"
                    break;
                case '1':
                    str = "已抽"
                    break;
                case '2':
                    str = "撤回"
                    break;
                default:
                    break;
            }
            return str;
        },
        formatterTime(row, column, data) {
            if (!data) {
                return "";
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
            return data.replace(reg, "$1-$2-$3 $4:$5:$6");
        },
        goBack() {
            this.$router.go(-1);
        }
    },

    mounted() {
        this.townCode = this.$route.params.townCode;
        if(this.$route.params.searchForm){
        this.searchForm = this.$route.params.searchForm
        }
        this.getTableData("init");
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/statistics/TownPeopleBCStatistics.vue